import { ThemeProvider } from "@emotion/react"
import { Shop } from "@mui/icons-material"
import { CssBaseline } from "@mui/material"
import React from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import { LocationAgent } from "../../_/BreadcrumbAgent"
import { CenterBox } from "../../_/CenterBox"
import BuyMeACoffee from "../../_/components/BuyMeACoffee"
import Bestiary from "../../bestiary/Bestiary"
import { Character } from "../../character/Character"
import { Contact } from "../../contact/Contact"
import { StaticSheet } from "../../create_character/Sheet"
import { Skills } from "../../create_character/Skills"
import { Fall } from "../../fall/Fall"
import { Fight } from "../../fight/Fight"
import { Focus } from "../../focus/Focus"
import { Header } from "../../header/Header"
import { Mechanics } from "../../mechanics/Mechanics"
import { Template } from "../../template/Template"
import theme from "../../theme"
import { MainSplot } from "./MainSplot"

export const Splot = () => {
    return (
        <ThemeProvider theme={theme}>
          <CssBaseline enableColorScheme={true}>
            <Template>
              <LocationAgent />
              <BuyMeACoffee />
              <Header />
              <CenterBox>

                <Routes>
                    <Route path="/splot/*" element={<MainSplot />}>
                        {/* <Route path="history" element={<HistorySplot />} />
                        <Route path="world" element={<WorldSplot />} />
                        <Route path="characters" element={<CharactersSplot />} />
                        <Route path="rules" element={<RouteSplot/>}  />                       
                        <Route path="*" element={<Navigate to="/focus" replace />} /> */}
                    </Route>
                </Routes>

              </CenterBox>
            </Template>
          </CssBaseline>
        </ThemeProvider>
    )
}